module.exports = __webpack_public_path__ + "static/media/map_skew@2x.1f202ccb.png";